// Mock content data for Structural Innovations landing page.
// All content lives here so backend wiring is trivial later.

import heroSteel from "./assets/images/hero-steel.jpg";
import glassBuilding from "./assets/images/glass-building.jpg";
import raacConcrete from "./assets/images/raac-concrete.jpg";
import industrySteel from "./assets/images/industry-steel.jpg";

export const IMAGES = {
  heroBg: heroSteel,
  glassBuilding: glassBuilding,
  raacProduct: raacConcrete,
  industryBg: industrySteel,
};

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Capabilities", href: "#capabilities" },
  { label: "RAAC BRAC", href: "#raac" },
  { label: "Contact", href: "#contact" },
];

export const HERO = {
  title: ["Engineering Systems.", "Practical Solutions."],
  paragraphs: [
    "Structural Innovations is an Isle of Man-based engineering and technology company supporting the development, management and commercial application of specialist structural systems.",
    "We work with engineering, manufacturing and delivery partners to bring practical solutions into commercial use in the UK and international markets.",
  ],
  primaryCta: { label: "Our Capabilities", href: "#capabilities" },
  secondaryCta: { label: "Explore RAAC BRAC", href: "#raac" },
};

export const INNOVATION = {
  heading: ["Built Around Practical", "Engineering Innovation"],
  paragraphs: [
    "Structural Innovations provides a dedicated platform for specialist engineering systems and technologies.",
    "We support the progression of technical concepts from development through to commercial application, working alongside experienced engineers, manufacturers and delivery partners.",
  ],
};

export const CAPABILITIES = [
  {
    icon: "DraftingCompass",
    title: "System Development",
    text: "Supporting the development and refinement of specialist structural and engineering systems to address real-world challenges.",
  },
  {
    icon: "Settings",
    title: "Technical Commercialisation",
    text: "Creating the technical and commercial framework required to bring engineering systems into wider industry use.",
  },
  {
    icon: "Handshake",
    title: "Licensing & Partnerships",
    text: "Working with approved engineering, manufacturing and delivery partners through structured commercial arrangements.",
  },
];

export const RAAC = {
  heading: "RAAC BRAC",
  paragraphs: [
    "RAAC BRAC is a specialist remedial support system developed for buildings containing reinforced autoclaved aerated concrete.",
    "Structural Innovations supports the management, development and commercial application of the RAAC BRAC system, working with specialist engineering and industry partners.",
  ],
  cta: { label: "Visit RAAC BRAC", href: "https://www.raacbrac.com/" },
};

export const INDUSTRY = {
  heading: "Working With Industry",
  paragraphs: [
    "We collaborate with structural engineers, consultants, manufacturers, fabricators and specialist contractors.",
    "Our role is to help provide the technical and commercial structure required to move innovative engineering systems into practical use.",
  ],
  items: [
    { icon: "Users", label: "Engineers" },
    { icon: "Factory", label: "Manufacturers" },
    { icon: "ClipboardList", label: "Consultants" },
    { icon: "HardHat", label: "Contractors" },
  ],
};

export const CONTACT = {
  heading: "Corporate & Partnership Enquiries",
  company: "Structural Innovations Limited",
  location: "Isle of Man",
  email: "hello@structuralinnovations.co.uk",
  website: "www.structuralinnovations.co.uk",
  companyNo: "Company No. 139176C",
  incorporation:
    "Structural Innovations Limited is incorporated in the Isle of Man.",
};

export const FOOTER = {
  copyright:
    "\u00A9 2026 Structural Innovations Limited. All rights reserved.",
};
